import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of, ReplaySubject, tap } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserService
{
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient)
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User)
    {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User>
    {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user data
     */
    getTeams(): Observable<any[]>
    {
        return this._httpClient.get<any[]>(`${environment.apis.lineupUrl}teams/v1`);
    }

    updateTeams(body): Observable<any[]>
    {
        return this._httpClient.put<any>(`${environment.apis.lineupUrl}teams/v1`, body);
    }

    getPhoto(): Observable<any> {
        return this._httpClient.get<any>(`${environment.apis.lineupUrl}user/v1/photo`);
    }

    updatePhoto(content): Observable<any> {
        return this._httpClient.put<any>(`${environment.apis.lineupUrl}user/v1/photo`, {content: content});
    }

    hasPermission(requiredPermission): Observable<boolean> {
        console.log('hasPermission', this.user.permissions)
        let display = this.user.permissions.includes(requiredPermission);

        return of<boolean>(display);
    }


    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any>
    {
        return this._httpClient.patch<User>('api/common/user', {user}).pipe(
            map((response) => {
                this._user.next(response);
            })
        );
    }
}
